export default __webpack_public_path__ + "static/media/laporan-tutup-kasir.979093ea.png";